// extracted by mini-css-extract-plugin
export default {"card":"Card__card--tADiL","clickable":"Card__clickable--FItXz","active":"Card__active--V_01Q","indicator":"Card__indicator--SR3nf","not-available":"Card__not-available--Z_To4"};